<template>
  <div class="row">
    <h4 class="col-4">Material za projekte</h4>
    <div class="col text-end">
      <button type="button" class="btn btn-success btn-sm ms-1 me-2 mb-2" @click="asyncAddMaterialsAction">
        Zahtevaj komisioniranje, rezervacijo ali naročilo
      </button>
      <button type="button" class="btn btn-info btn-sm me-2 mb-2" v-show="canChange" @click="showBomTemplates = true">
        <span class="d-none d-md-inline">Dodaj material</span> iz predloge
      </button>
      <button
        type="button"
        class="btn btn-warning btn-sm me-2 mb-2"
        v-show="canChange"
        @click="sectionForAddMaterial = { order: 1000, name: 'Ročno dodan' }"
      >
        Dodaj <span class="d-none d-md-inline">material</span>
      </button>
    </div>
  </div>

  <div class="row" v-if="sortedMaterials?.length">
    <div class="col d-block d-md-none">
      <!-- for delete -->
      <div class="card mb-2 mt-2" v-for="m in sortedMaterials.filter((m) => !m.isForDelete)">
        <div class="card-body" role="button" @click="selectMaterial(m)">
          <h6 class="card-subtitle">
            <span class="fw-light">{{ m.quantity }}{{ m.measurementUnit }}</span> {{ m.materialName }}
          </h6>
        </div>
      </div>
    </div>
    <div class="col d-none d-md-block d-lg-block">
      <table
        class="table table-sm table-hover table-sticky-header"
        v-show="sortedMaterials.filter((m) => m.isForDelete !== true).length"
      >
        <thead class="thead-light bg-light">
          <tr>
            <th></th>
            <th>Komisioniranje</th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'section' && sort.dir === 'asc',
                desc: sort.by === 'section' && sort.dir === 'desc',
              }"
              @click="sortBy('section')"
            >
              Sekcija
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'materialName' && sort.dir === 'asc',
                desc: sort.by === 'materialName' && sort.dir === 'desc',
              }"
              @click="sortBy('materialName')"
            >
              Naziv artikla
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'opPisProductID' && sort.dir === 'asc',
                desc: sort.by === 'opPisProductID' && sort.dir === 'desc',
              }"
              @click="sortBy('opPisProductID')"
            >
              Ident
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'quantity' && sort.dir === 'asc',
                desc: sort.by === 'quantity' && sort.dir === 'desc',
              }"
              @click="sortBy('quantity')"
            >
              Predvidena poraba za projekt
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'remainingUsage' && sort.dir === 'asc',
                desc: sort.by === 'remainingUsage' && sort.dir === 'desc',
              }"
              @click="sortBy('remainingUsage')"
            >
              Do predvidene porabe
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'stockCe' && sort.dir === 'asc',
                desc: sort.by === 'stockCe' && sort.dir === 'desc',
              }"
              @click="sortBy('stockCe')"
            >
              Prosta zaloga skladišča CE
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'commissionCompletedQuantity' && sort.dir === 'asc',
                desc: sort.by === 'commissionCompletedQuantity' && sort.dir === 'desc',
              }"
              @click="sortBy('commissionCompletedQuantity')"
            >
              Komisionirano 055
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'commissionInProgress' && sort.dir === 'asc',
                desc: sort.by === 'commissionInProgress' && sort.dir === 'desc',
              }"
              @click="sortBy('commissionInProgress')"
            >
              Komision v pripravi
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'deliveredNormalQuantityPlus' && sort.dir === 'asc',
                desc: sort.by === 'deliveredNormalQuantityPlus' && sort.dir === 'desc',
              }"
              @click="sortBy('deliveredNormalQuantityPlus')"
            >
              Osebni prevzem 050
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'deliveredNormalQuantityMinus' && sort.dir === 'asc',
                desc: sort.by === 'deliveredNormalQuantityMinus' && sort.dir === 'desc',
              }"
              @click="sortBy('deliveredNormalQuantityMinus')"
            >
              Osebno vračilo 050
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'totalIssued' && sort.dir === 'asc',
                desc: sort.by === 'totalIssued' && sort.dir === 'desc',
              }"
              @click="sortBy('totalIssued')"
            >
              Skupaj izdano
            </th>
            <th
              class="sortable"
              :class="{
                asc: sort.by === 'executedDelivery' && sort.dir === 'asc',
                desc: sort.by === 'executedDelivery' && sort.dir === 'desc',
              }"
              @click="sortBy('executedDelivery')"
            >
              Dobavljeno po naročilu
            </th>
            <th>Rezervacija</th>
            <th colspan="2">Naročanje</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr
            v-for="m in sortedMaterials.filter((m) => !m.isForDelete)"
            :class="{
              clickable: canChange,
              'added-today': isAddedToday(m),
            }"
          >
            <td>
              <span class="badge bg-warning" v-show="m.commissionedQuantity - m.commissionCompletedQuantity > 0"
                >KOM</span
              >
              <span
                class="badge bg-danger"
                v-show="m.commissionCompletedQuantity + m.deliveredNormalQuantity > m.quantity"
                >IZD</span
              >
              <span class="badge bg-primary" v-show="m.hasReplacment">NAD-</span>
              <span class="badge bg-success" v-show="m.isReplacing">NAD+</span>
              <span class="badge bg-info" v-show="m.requiresSerialNumbers && m.serialNumbers">SER</span>
              <span class="badge bg-danger text-dark" v-show="m.requiresSerialNumbers && !m.serialNumbers">SER!</span>
              <span class="badge bg-secondary" v-show="m.orderedQuantity > 0">NAR</span>
            </td>
            <td>
              <input
                type="number"
                v-model="m.commissionQuantity"
                class="form-control form-control-sm"
                style="width: 100px"
              />
            </td>
            <td @click="selectMaterial(m)">{{ m.sectionName }}</td>
            <td @click="selectMaterial(m)">{{ m.materialName }}</td>
            <td @click="selectMaterial(m)">{{ m.opPisProductID }}</td>
            <td @click="selectMaterial(m)">
              <span class="badge bg-secondary">{{ m.quantity }}</span>
            </td>
            <td @click="selectMaterial(m)">
              {{ -(m.quantity - (m.commissionCompletedQuantity + m.deliveredNormalQuantity)) }}
            </td>
            <td @click="selectMaterial(m)">
              <span v-show="m.isStockUpToDate">{{ m.stockCe - m.reservedCe }}</span>
            </td>
            <td @click="selectMaterial(m)">[🚚{{ m.commissionCompletedQuantity - m.totalReplacementQuantity }}]</td>
            <td @click="selectMaterial(m)">
              {{
                m.commissionedQuantity - m.commissionCompletedQuantity > 0
                  ? m.commissionedQuantity - m.commissionCompletedQuantity
                  : 0
              }}
            </td>
            <td @click="selectMaterial(m)">{{ m.deliveredNormalQuantityPlus }}</td>
            <td @click="selectMaterial(m)">{{ -m.deliveredNormalQuantityMinus }}</td>
            <td @click="selectMaterial(m)">
              {{ m.commissionCompletedQuantity + m.deliveredNormalQuantity - m.totalReplacementQuantity }}
              {{ m.measurementUnit }}
            </td>
            <td @click="selectMaterial(m)">{{ m.executedDelivery }}</td>
            <td>
              <input
                type="number"
                v-model="m.reserveQuantity"
                @change="$emit('changeReservation', m)"
                class="form-control form-control-sm"
                style="width: 100px"
              />
            </td>
            <td>
              <input
                type="number"
                v-model="m.orderQuantity"
                @change="$emit('changeReservation', m)"
                class="form-control form-control-sm"
                style="width: 100px"
              />
            </td>
            <td>
              <span class="badge bg-primary" v-show="m.orderedQuantity > 0"
                >{{ m.orderedQuantity }} @
                {{
                  $dayjs(m.expectedDelivery).year() > 99
                    ? $dayjs(m.expectedDelivery).format($DATE_FORMAT_DISPLAY)
                    : "Ni roka dobave."
                }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <BomTemplates
    :visible="showBomTemplates"
    :quantity="quantity"
    @close="showBomTemplates = false"
    @add="asyncAddMaterials"
  />

  <WorkOrderMaterialActions
    v-model="materialForActions"
    @close="
      (e) => {
        if (e === true) {
          loadMaterialsAsync(workOrderType, workOrderId)
        }
        materialForActions = null
      }
    "
    :canChange="canChange"
    :showWarehouse="false"
    :workOrderType="workOrderType"
    :workOrderId="workOrderId"
    :showOrderMaterial="true"
    :showNotPartOfOffer="false"
    :canDeleteMaterial="true"
  />

  <SelectMaterial
    v-if="canChange"
    :quantity="quantity"
    :useBarcode="true"
    :serialsRequired="false"
    :section="sectionForAddMaterialBarcode"
    :visible="!!sectionForAddMaterialBarcode"
    @close="sectionForAddMaterialBarcode = null"
    @add="asyncAddMaterials"
  />

  <SelectMaterial
    v-if="canChange"
    :quantity="quantity"
    :serialsRequired="false"
    :section="sectionForAddMaterial"
    :visible="!!sectionForAddMaterial"
    @close="sectionForAddMaterial = null"
    @add="asyncAddMaterials"
  />
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { setError, startLoading, stopLoading, setSuccess, setWarning } from "./Notification"
import WorkOrderMaterialActions from "./WorkOrderMaterialActions.vue"
import BomTemplates from "../components/BomTemplates.vue"
import SelectMaterial from "../components/SelectMaterial.vue"
import MaterialsList from "../components/MaterialsList.vue"
import { getEntityAsync, saveMaterialsAsync } from "../api"
import { isAddedToday } from "../utils/timeEntryExtensions"

defineOptions({ name: "ProjectMaterials" })

const props = defineProps({
  canChange: Boolean,
  workOrderType: { type: String, required: true },
  workOrderId: { type: String },
  quantity: { type: Number, default: 1 },
  enableBarcode: { type: Boolean, default: true },
})

const emit = defineEmits(["changeSelection", "commissioned"])

const { fetchAuthAsync } = useAuth()
const materialForActions = ref(null)
const sectionForAddMaterial = ref(null)
const sectionForAddMaterialBarcode = ref(null)
const showBomTemplates = ref(false)
const materials = ref([])
const sort = ref({ by: "materialName", dir: "asc" })

// a v-on value is parsed as statements only while it contains a `;`, otherwise as a single
// expression - so multi-statement handlers live here, where formatting cannot invalidate them
const sortBy = (by) => {
  sort.value.by = by
  sort.value.dir = sort.value.dir === "desc" ? "asc" : "desc"
}

const loadMaterialsAsync = async (materialRelation, relationId) => {
  const res = await getEntityAsync(fetchAuthAsync, `Materials/${materialRelation}`, relationId)
  materials.value = (res || []).map((m) => ({
    ...m,
    commissionQuantity: m.commissionQuantity ?? 0,
    reserveQuantity: m.reserveQuantity ?? 0,
    orderQuantity: m.orderQuantity ?? 0,
  }))
}

const sortedMaterials = computed(() => {
  if (!sort.value.by || !materials.value.length) return materials.value
  const getSortValue = (m) => {
    switch (sort.value.by) {
      case "remainingUsage":
        return -(m.quantity - (m.commissionCompletedQuantity + m.deliveredNormalQuantity))
      case "commissionInProgress":
        return m.commissionedQuantity - m.commissionCompletedQuantity > 0
          ? m.commissionedQuantity - m.commissionCompletedQuantity
          : 0
      case "totalIssued":
        return m.commissionCompletedQuantity + m.deliveredNormalQuantity - m.totalReplacementQuantity
      default:
        return m[sort.value.by]
    }
  }

  return materials.value.slice().sort((a, b) => {
    const aValue = getSortValue(a)
    const bValue = getSortValue(b)
    if (aValue === null || aValue === undefined) return sort.value.dir === "asc" ? -1 : 1
    if (bValue === null || bValue === undefined) return sort.value.dir === "asc" ? 1 : -1
    if (typeof aValue === "string" && typeof bValue === "string") {
      return sort.value.dir === "asc" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
    }
    return sort.value.dir === "asc" ? aValue - bValue : bValue - aValue
  })
})

const asyncAddMaterials = async (m) => {
  const materialsToAdd = []
  m.forEach((m) => {
    const found = materials.value.find((e) => e.materialID === m.materialID)
    if (!found) {
      m.isNew = true
      materials.value.push(m)
      materialsToAdd.push(m)
    } else if (!found.isForDelete) {
      found.quantity += m.quantity
      found.isDirty = true
      materialsToAdd.push(found)
    } else {
      found.quantity = m.quantity
      found.isDirty = true
      found.isForDelete = false
      materialsToAdd.push(found)
      console.warn("adding deleted material")
    }
  })
  const result = await saveMaterialsAsync(fetchAuthAsync, materialsToAdd, props.workOrderType, props.workOrderId)
  if (result) {
    await loadMaterialsAsync(props.workOrderType, props.workOrderId)
    setSuccess("Material dodan..", true)
    showBomTemplates.value = false
  } else {
    console.error("materials not saved.")
  }
}

const asyncAddMaterialsAction = async () => {
  const commissionMaterials = materials.value
    .filter((cm) => cm.commissionQuantity > 0)
    .map((m) => ({
      ...m,
      quantity: m.commissionQuantity,
      isNew: true,
    }))
  console.log("Commission materials:", commissionMaterials)
  const reserveMaterials = materials.value
    .filter((cm) => cm.reserveQuantity > 0)
    .map((m) => ({
      ...m,
      quantity: m.reserveQuantity,
      isNew: true,
    }))
  const orderMaterials = materials.value
    .filter((cm) => cm.orderQuantity > 0)
    .map((m) => ({
      ...m,
      quantity: m.orderQuantity,
      isNew: true,
    }))
  let resultCommission, resultReservation, resultOrder
  if (commissionMaterials.length !== 0) {
    resultCommission = await saveMaterialsAsync(
      fetchAuthAsync,
      commissionMaterials,
      `Commission${props.workOrderType}`,
      props.workOrderId,
    )
  }
  if (reserveMaterials.length !== 0) {
    resultReservation = await saveMaterialsAsync(
      fetchAuthAsync,
      reserveMaterials,
      `Reserve${props.workOrderType}`,
      props.workOrderId,
    )
  }
  if (orderMaterials.length !== 0) {
    resultOrder = await saveMaterialsAsync(
      fetchAuthAsync,
      orderMaterials,
      `Order${props.workOrderType}`,
      props.workOrderId,
    )
  }
  if (resultCommission || resultReservation || resultOrder) {
    emit("commissioned") // do we need this?
    setSuccess("Zahtevek oddan.", true)
    await loadMaterialsAsync(props.workOrderType, props.workOrderId)
  } else {
    setError("Komisioniranje ni bilo uspešno.")
  }
}

watch(
  () => props.workOrderId,
  async (newId) => {
    if (newId) {
      await loadMaterialsAsync(props.workOrderType, props.workOrderId)
    }
  },
  { immediate: true },
)

const selectMaterial = (m) => {
  if (props.canChange) {
    materialForActions.value = m
  }
}
</script>
